import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import axios from 'axios';
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';

const Contact = () => {

    const messageState = useSelector(state => state.message);
    const [firstName, setFirstName] = useState('');  //local hooks
    const [lastName, setLastName] = useState('');  //local hooks
    const [email, setEmail] = useState('');  //local hooks
    const [comments, setComments] = useState('');  //local hooks
    const [captcha, setCaptcha] = useState('');  //local hooks
    const dispatch = useDispatch();  //Assign useDispatch so we can use it...

    const dataPost = {
        firstName: firstName,
        lastName: lastName,
        username: email,
        email: email,
        comments: comments
    }

    useEffect(() => {
        dispatch({ type: 'SYSMESSAGE', message: '' });
        loadCaptchaEnginge(8);
    }, [dispatch]);

    const submitContact = () => {
        //only submit when Captcha is true
        if (validateCaptcha(captcha, false) === true) {
            axios.post('/contact/contactPost', dataPost)
            .then((res) => { 
                dispatch({ type: 'SYSMESSAGE', message: '' });
            })
            .catch (err => {
                dispatch({ type: 'SYSMESSAGE', message: 'Data in form issue!', messageType: 'alert alert-warning' });
            });
        } else {
            dispatch({ type: 'SYSMESSAGE', message: 'Captcha does not match', messageType: 'alert alert-danger' });
        }
    }

    let printMessage = '';
    if(messageState.message){
        printMessage = (
            <div className={messageState.messageType} role="alert">
                {messageState.message}
            </div>
        )
    }
    
    return(
        <>
            <div className="container" style={{ marginTop: 50 }}>
            <div className="form-product-create">
                    <h3>Contact</h3>
                    {printMessage}
                    <div className="form-floating">
                        <input type="firstName" className="form-control" placeholder="Your - First Name" 
                            onChange={event => setFirstName(event.target.value)} />
                        <label>First Name</label>
                    </div>
                    <br />

                    <div className="form-floating">
                        <input type="lastName" className="form-control" placeholder="Your - Last Name" 
                            onChange={event => setLastName(event.target.value)} />
                        <label>Last Name</label>
                    </div>
                    <br />

                    <div className="form-floating">
                        <input type="email" className="form-control" placeholder="Your - Email" 
                            onChange={event => setEmail(event.target.value)} />
                        <label>Email</label>
                    </div>
                    <br />

                    <div className="form-floating">
                        <input type="contactComments" className="form-control" placeholder="Type your comments here" 
                            onChange={event => setComments(event.target.value)} />
                        <label>Comments</label>
                    </div>
                    <br />

                    <div style={{ display: 'flex', justifyContent:'center', alignItems:'center', width: 620, padding: 10, border: '1px solid rgba(0, 0, 0, 0.05)' }}>
                        < LoadCanvasTemplate reloadColor="red" />

                        <div className="form-floating">
                            <input style={{ width:190 }} type="captcha" className="form-control" placeholder="Enter Captcha" 
                                onChange={event => setCaptcha(event.target.value)} />
                            <label>Captcha</label>
                        </div>
                    </div>

                    <button className="btn btn-primary" onClick={() => submitContact()}>Submit</button>
            </div>
            </div>
        </>
    )
}
export default Contact;
